// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { Grid } from 'semantic-ui-react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { StyledHeader } from '@src/common-utils/styledComponents';
import { Spacer } from '@presentational/spacing/Spacer';
import { ClusterLinkingWorkloadContext } from '@streaming-projects/workloads/cluster-linking-workloads/contexts/ClusterLinkingWorkloadContext';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG } from '@streaming-projects/workloads/cluster-linking-workloads/config';

export const SPClusterLinkingWorkloadResourceDetailsContainer = () => {
  const workloadData = useContext(ClusterLinkingWorkloadContext);
  const workloadResourceDetails = workloadData.cluster_linking_resource_details;
  const { values, initialValues } = useFormikContext();

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    CLUSTER_LINKING_WORKLOAD_DETAILS_CONFIG
  );

  return (
    <>
      <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
        <Grid columns={3} divided={true}>
          <Grid.Row>
            <Grid.Column>
              <StyledHeader> Cluster Link Name </StyledHeader>
              <Spacer y={20} />
              {workloadResourceDetails.name}
            </Grid.Column>
            <Grid.Column>
              <StyledHeader> Source Cluster Name </StyledHeader>
              <Spacer y={20} />
              {workloadResourceDetails.source_cluster_name}
            </Grid.Column>
            <Grid.Column>
              <StyledHeader> Destination Cluster Name </StyledHeader>
              <Spacer y={20} />
              {workloadResourceDetails.destination_cluster_name}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </PaddedAndRaisedSegment>
    </>
  );
};
